import {TemplateItemImpl} from "@/store/settings/templates/types";

export interface TemplatesState {
    mailNotifyTemplates?: any
    mailNotifyTemplateItem?: MailNotifyTemplateItemImpl
    mnRoutesList: string[]
}

export class MailNotifyTemplateItemImpl extends TemplateItemImpl {
    mn_service_id:number|null;
    service_provider_id:number|null;
    mn_template_id:number|null;
    vk_message:string;
    ok_message:string;
    routes:string;
    multichannel_positive_sending: number;

    constructor() {
        super();
        this.mn_service_id = null;
        this.service_provider_id = null;
        this.mn_template_id = null;
        this.vk_message = '';
        this.ok_message = '';
        this.routes = 'vk';
        this.multichannel_positive_sending = 0;
    }
}


